import { FC } from 'react';

const NoDairyIcon: FC = () => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 65.625C51.9137 65.625 65.625 51.9137 65.625 35C65.625 18.0863 51.9137 4.375 35 4.375C18.0863 4.375 4.375 18.0863 4.375 35C4.375 51.9137 18.0863 65.625 35 65.625Z"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M51.334 52.5L55.8548 57.3125"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.291 12.834L19.9785 18.959"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M47.2497 54.1048H22.458V29.1673L27.1247 22.6048V15.8965H41.5622V22.6048L47.2497 29.459V54.1048"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.125 22.6035H40.9792"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1875 29.166H36.1667V54.1035"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.166 29.3119L40.9785 22.6035"
        stroke="black"
        strokeOpacity="0.87"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoDairyIcon;
